/**
 * What a Guest (a brand's client, see usePermissions) may open in the cockpit.
 *
 * Guests get Universe (read-only), Trends, References, Workshop, the client
 * view of the Calendar, the strategies sent to them (Strategy renders
 * GuestStrategyView for a guest), and a personal-only Settings. Home, Signals
 * and the dev tools read team-only data the server refuses them, so they are
 * neither linked nor reachable by URL.
 */

/** Where a guest lands, and where a blocked URL sends them. */
export const GUEST_HOME_PATH = "/dashboard/workshop";

/** Dashboard child segments a guest may open ("" is Home, which they may not). */
const GUEST_ALLOWED_SEGMENTS = new Set([
  "brand-universe",
  "content-calendar",
  "content-review",
  "strategy",
  "workshop",
  "settings",
  "trends",
  "references",
]);

/** NavRail destinations (its `to` values) hidden from guests. */
export const GUEST_HIDDEN_NAV = new Set([".", "market-signals"]);

/** True when a /dashboard URL is off-limits to a guest. */
export function isGuestBlockedPath(pathname: string): boolean {
  const rest = pathname.replace(/^\/dashboard\/?/, "");
  const segment = rest.split("/")[0] ?? "";
  return !GUEST_ALLOWED_SEGMENTS.has(segment);
}
